import { useQuery } from "react-query";
import { organisationSignal } from "../../../signal/organisationSignal";
import OrderLock from "./OrderLock";
import axios from "axios";
import { DEV_SERVER } from "../../../constants/urls";
import { userSignal } from "../../../signal/userSignal";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";



export default function OrderGuard(props) {

    const [orgData, setOrgData] = useState(organisationSignal.value);
    const [loading, setLoading] = useState(true);

    const getOrgData = useQuery("orgData", async () => {
        const response = await axios.get(`${DEV_SERVER}/auth/v2/organisation`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            }
        })
        return response.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setOrgData(data.data);
                organisationSignal.value = data.data
                setLoading(false);
            }
        },
        onError: (error) => {
            console.log(error);
        }
    })

    useEffect(() => {
        if (organisationSignal.value === null) {
            getOrgData.refetch({ cancelRefetch: true })
        } else {
            setLoading(false);
        }
    }, [])

    return (
        <>
            {loading ?
                <div>
                    <Row>
                        <Col sm="12">
                            <Card>
                                <Card.Header className="d-flex justify-content-between">
                                    <div className="header-title">
                                        <h4 className="card-title">Order Module</h4>
                                    </div>
                                </Card.Header>

                                <Card.Body>
                                    <div className="d-flex justify-content-center">
                                        <div className="spinner-border" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </div>
                                </Card.Body>

                            </Card>
                        </Col>
                    </Row>
                </div>

                :

                orgData?.isOrderModuleActivated ?
                    <>
                        {props.children}
                    </>
                    :
                    <OrderLock />
            }
        </>
    )

}